export default __webpack_public_path__ + "static/media/img_raund_light.361aa35b.png";